import * as actions from 'actions';
import {useSelector, useDispatch} from "react-redux";

const usePopup=()=> {
    const popup = useSelector(state => state.popup);
    const dispatch = useDispatch();

    const showPopup=(title, text)=> {
        dispatch(actions.showPopup({show:true, title, text}));
    }
    const closePopup=()=> {
        dispatch(actions.closePopup());
    }

    return {popup, showPopup, closePopup};
};

export default usePopup;